import { useState } from "react";
import SectionTitle from "./SectionTitle";
import { columns } from "@/mocks/gossip";

export default function Columns() {
  const [watched, setWatched] = useState<number[]>([]);

  const toggle = (id: number) =>
    setWatched((prev) => (prev.includes(id) ? prev.filter((k) => k !== id) : [...prev, id]));

  return (
    <section id="columns" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-7 px-4 py-12 md:px-6 md:py-16">
        <SectionTitle
          id="columns"
          index="03"
          title="运营分区 · 按题材蹲各自的瓜"
          accent="CHANNELS · ZONES"
          desc="顶流、综艺、网红、反转分区分得明明白白，想追哪条线就进哪个板块蹲着。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {columns.map((c) => {
            const on = watched.includes(c.id);
            return (
              <article
                key={c.id}
                className="group flex cursor-pointer flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition hover:border-primary-300"
              >
                <div className="relative w-full">
                  <div className="aspect-[16/10] w-full">
                    <img
                      src={c.cover}
                      alt={`吃瓜91分栏-${c.name}`}
                      title={`吃瓜91 ${c.name} 蹲点板块`}
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent" />
                  <span
                    className={`absolute left-3 top-3 inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-bold text-background-50 ${c.tone}`}
                  >
                    <i className="ri-tv-2-line" /> {c.name}
                  </span>
                  <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-foreground-950/55 px-2.5 py-1 text-xs font-semibold text-background-50 backdrop-blur-sm">
                    <i className="ri-user-heart-fill" />
                    <span className="num">{c.watchers.toLocaleString()}</span> 人蹲
                  </span>
                </div>

                <div className="flex flex-1 flex-col gap-3 p-4 md:p-5">
                  <p className="text-sm leading-relaxed text-foreground-700">{c.desc}</p>
                  <div className="mt-auto flex items-center justify-between gap-3 border-t border-background-100 pt-3">
                    <div className="flex items-center gap-3 text-xs text-foreground-600">
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-flashlight-fill text-accent-600" />
                        <span className="num font-bold text-foreground-900">{c.updates}</span> 条更新
                      </span>
                    </div>
                    <button
                      onClick={() => toggle(c.id)}
                      className={`inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-bold transition ${
                        on
                          ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                          : "border border-background-300 bg-background-50 text-foreground-800 hover:border-primary-400 hover:text-primary-600"
                      }`}
                    >
                      <i className={on ? "ri-checkbox-circle-fill" : "ri-add-circle-line"} />
                      {on ? "已在蹲点" : "去蹲一个"}
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}